import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { AppBar, Toolbar, IconButton, Button, Drawer, List, ListItem, ListItemText, TextField, Box, Typography, Container, Grid, Slide } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Navigate, useLocation  } from 'react-router-dom';

import HomeLayout from "layouts/authentication/components/HomeLayout";

import BannerCarousel from "layouts/authentication/components/BannerCarousel";

const Home = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loggedIN,setLoggedIN] = useState(false);


  useEffect(() => {

    const udata = localStorage.getItem('user');

    if (udata !== null) {
      setLoggedIN(true);
    }

  }, []);

  // Toggle Drawer open/close
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // if (loggedIN) {

  //   return <Navigate to="/dashboard" />

  // }

  return (
    <HomeLayout>
      <Box sx={{ py: 0, backgroundColor: "#ffff" }}>
       <BannerCarousel />
      </Box>
    </HomeLayout>
  );
};


export default Home;